<template>
  <ConfirmDialog></ConfirmDialog>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Proformas</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">Proformas</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Proformas
          <Badge size="xlarge" severity="success"> {{ totalRegistros }}</Badge>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="dtproformas"
        :value="proformas"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :filters="buscar"
        :loading="cargando"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 50, 100]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Proformas"
        responsiveLayout="scroll"
        showGridlines
      >
        <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar..."
              />
            </span>
          </div>
        </template>
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >
        <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>
        <Column field="numero" header="Nº PROFORMA">
          <template #body="{ data }">
            <div class="flex align-items-center">
              <span class="font-bold">{{ data.numero }}</span>
            </div>
          </template>
        </Column>
        <Column field="cliente" header="CLIENTE"></Column>
        <Column field="fecha" header="FECHA"> </Column>
        <Column field="vendedor" header="VENDEDOR"> </Column>
        <Column field="total" header="TOTAL" class="text-right"> </Column>
        <Column field="valido_hasta" header="VALIDO HASTA"> </Column>
        <Column field="observacion" header="OBSERVACIÓN"> </Column>
        <Column field="estado" header="ESTADO" class="text-center">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado]">
              <!-- Icons -->
              <i class="pi pi-check" v-if="data.estado == 1"></i>
              <i class="pi pi-times" v-else-if="data.estado == 0"></i>
            </span>
          </template>
        </Column>
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              icon="pi pi-ellipsis-v"
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Ver Acciones'"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            ></Button>
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            ></Menu>
            <!-- Botón para imprimir usando VueHtml2pdf (con previsualización) -->
            <!-- <Button
              icon="pi pi-print"
              class="p-button-text p-button-sm ml-2"
              v-tooltip.top="'Descargar Proforma'"
              @click="descargarProformaPdf(slotProps.data)"
            ></Button> -->
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
  <!-- Botón de imprimir PDF dentro del header del diálogo -->
  <Dialog
    v-model:visible="showPdfDialog"
    :modal="true"
    header="Descargar PDF"
    :style="{
      width: '100vw',
      maxWidth: '100vw',
      minWidth: '320px',
      top: '0',
      left: '0',
      margin: '0',
      padding: '0',
      zIndex: 1200,
    }"
    :contentStyle="{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0',
      minHeight: '100vh',
      background: '#f4f4f4',
      zIndex: 1201,
    }"
    :closable="true"
    :dismissableMask="true"
    :draggable="false"
    :blockScroll="true"
    :breakpoints="{ '960px': '98vw', '640px': '100vw' }"
    :baseZIndex="1200"
  >
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      "
    >
      <!-- Botones SIEMPRE arriba de la previsualización -->
      <div
        style="
          display: flex;
          justify-content: flex-end;
          margin-bottom: 10px;
          width: 100%;
          max-width: 820px;
          margin-left: auto;
          margin-right: auto;
          position: relative;
          z-index: 2000;
        "
      >
        <Button
          label="Descargar PDF"
          icon="pi pi-download"
          class="p-button-success pdf-download-btn"
          @click="generarYDescargarPdf"
          :disabled="pdfLoading"
          style="z-index: 2001; position: relative"
        />
        <Button
          label="Cerrar"
          icon="pi pi-times"
          class="p-button-text ml-2"
          @click="showPdfDialog = false"
          style="z-index: 2001; position: relative"
        />
      </div>
      <!-- Previsualización PDF -->
      <div style="width: 100%; display: flex; justify-content: center">
        <div
          ref="previsualizacionPdf"
          style="
            background: #fff;
            box-shadow: none;
            width: 100%;
            max-width: 800px;
            margin: 0 auto;
            padding: 24px 18px;
            min-width: 700px;
          "
        >
          <ProformaPdf :proforma="proformaSeleccionada" />
        </div>
      </div>
    </div>
  </Dialog>
  <Dialog
    v-model:visible="showPdfDialog"
    :modal="true"
    header="Imprimir Proforma"
    :style="{
      width: '95vw',
      maxWidth: '820px',
      zIndex: 1300,
      borderRadius: '18px',
      boxShadow: '0 8px 32px rgba(60,60,60,0.18)',
      background: '#fff',
      border: 'none',
      padding: '0',
    }"
    :contentStyle="{
      overflow: 'auto',
      padding: '0',
      minHeight: '60vh',
      maxHeight: '80vh',
      background: '#fff',
      borderRadius: '0 0 18px 18px',
      boxShadow: 'none',
      border: 'none',
    }"
    :breakpoints="{ '960px': '98vw', '640px': '99vw' }"
    :draggable="false"
    :closable="true"
    :dismissableMask="true"
    :blockScroll="true"
    :showHeader="true"
    :showFooter="false"
    :focusOnShow="true"
    :baseZIndex="1300"
    class="custom-pdf-dialog"
  >
    <VueHtml2pdf
      :show-layout="true"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="proforma.pdf"
      :pdf-quality="2"
      :manual-pagination="true"
      ref="html2Pdf"
      style="
        pointer-events: auto;
        background: transparent;
        box-shadow: none;
        z-index: 1;
      "
    >
      <template v-slot:pdf-content>
        <div
          style="
            background: #fff;
            padding: 32px;
            min-width: 700px;
            max-width: 800px;
            margin: auto;
            box-shadow: none;
          "
        >
          <ProformaPdf
            v-if="proformaSeleccionada"
            :proforma="proformaSeleccionada"
            @logo-ready="onLogoReady"
          />
        </div>
      </template>
    </VueHtml2pdf>
  </Dialog>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import VentaService from "@/service/VentaService";
import ProformaService from "@/service/ProformaService";
import { useAuth } from "@/stores";
import ProformaPdf from "./ProformaPdf.vue";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      proformas: [],
      totalRegistros: 0,
      cargando: false,
      buscar: {
        global: { matchMode: FilterMatchMode.CONTAINS, value: null },
      },
      claseEstado: ["status-outofstock", "status-instock", "status-lowstock"],
      showPdfDialog: false,
      proformaSeleccionada: null,
      pdfLoading: true,
    };
  },
  ventaService: null,
  proformaService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.ventaService = new VentaService();
    this.proformaService = new ProformaService();
  },
  mounted() {
    this.cargarProformas();
  },
  methods: {
    // Descarga desde el botón del diálogo usando jsPDF + html2canvas (igual que ProformaDetalle)
    async generarYDescargarPdf() {
      this.pdfLoading = true;
      try {
        await this.$nextTick();
        const element = this.$refs.previsualizacionPdf;
        if (!element) {
          alert("No se encontró el contenido para exportar.");
          this.pdfLoading = false;
          return;
        }
        const canvas = await html2canvas(element, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "pt",
          format: "a4",
        });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let position = 0;
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        let remainingHeight = imgHeight;
        while (remainingHeight > pageHeight) {
          position = position - pageHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          remainingHeight -= pageHeight;
        }
        pdf.save("proforma.pdf");
        this.showPdfDialog = false;
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        alert("Error al generar el PDF.");
      }
      this.pdfLoading = false;
    },
    async descargarProformaPdf(proforma) {
      // Carga los datos completos si es necesario
      let datos = proforma;
      if (!proforma.cliente || !proforma.numero) {
        datos = await this.proformaService.buscarProforma(proforma.id);
      }
      this.proformaSeleccionada = null;
      await this.$nextTick();
      this.proformaSeleccionada = datos;
      this.showPdfDialog = true;
      this.pdfLoading = false;
      await this.$nextTick();
      // Forzar el foco en el botón de imprimir PDF del modal
      const btn = document.querySelector(".p-button-success");
      if (btn) btn.focus();
    },
    acciones(datos) {
      return [
        {
          label: "Ver Detalle",
          icon: "pi pi-fw pi-eye",
          disabled:
            "Proforma Ver Detalle" in this.auth.user.permissions ? false : true,
          to: `/proforma/${datos.id}/detalle`,
        },
        {
          label: "Descargar PDF",
          disabled:
            "Proforma DescargarPDF" in this.auth.user.permissions
              ? false
              : true,
          icon: "pi pi-fw pi-file-pdf",
          command: () => this.imprimirDirecto(datos),
        },
        {
          label: "Anular Proforma",
          icon: "pi pi-fw pi-trash",
          disabled:
            datos.estado == 0
              ? true
              : false || "Proforma Anular" in this.auth.user.permissions
              ? false
              : true,
          command: () => this.deleteProforma(datos.id),
        },
      ];
    },
    deleteProforma(id) {
      this.$confirm.require({
        message: "¿Está seguro que desea anular la venta?",
        header: "Anular Proforma",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, deseo Anular",
        rejectLabel: "No, Cancelar",
        accept: () => {
          this.ventaService.anularProforma(id).then((response) => {
            this.$toast.add({
              severity: "success",
              summary: "Proforma Anulada",
              detail: response.mensaje,
              life: 3000,
            });
            this.cargarProformas();
          });
        },
      });
    },

    cargarProformas() {
      this.cargando = true;
      this.ventaService.getAllProformas().then((response) => {
        this.proformas = response.proformas;
        this.cargando = false;
      });
    },
    imprimirProforma(id) {
      this.ventaService
        .imprimirVentaProforma(id)
        .then((data) => {
          console.log(data);
        })
        .catch((error) => console.log(error));
    },
    async imprimirDirecto(proforma) {
      // Alias para descargarProformaPdf
      await this.descargarProformaPdf(proforma);
    },
    // openPdfDialog y downloadPdf ya no son necesarios
    // onLogoReady ya no es necesario
  },
  watch: {
    proformas() {
      this.totalRegistros = this.proformas.length;
    },
  },
  components: {
    ProformaPdf,
  },
};
</script>
<style scoped lang="scss">
.force-center-dialog >>> .p-dialog {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  position: fixed !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
}
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
.p-component-overlay {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.custom-pdf-dialog .p-dialog {
  border-radius: 18px !important;
  box-shadow: 0 8px 32px rgba(60, 60, 60, 0.18) !important;
  background: #fff !important;
  border: none !important;
  margin: auto !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  position: fixed !important;
}
.custom-pdf-dialog .p-dialog-header {
  border-radius: 18px 18px 0 0 !important;
  background: #f8f9fa !important;
  border-bottom: 1px solid #e0e0e0 !important;
  font-size: 1.2rem;
  font-weight: 600;
  color: #222;
  padding: 1.2rem 2rem 1.2rem 2rem !important;
}
.custom-pdf-dialog .p-dialog-content {
  background: #fff !important;
  filter: none !important;
  -webkit-filter: none !important;
  overflow: auto !important;
  box-shadow: none !important;
  border-radius: 0 0 18px 18px !important;
  padding: 0 !important;
}
.custom-pdf-dialog .p-dialog-footer {
  position: sticky;
  bottom: 0;
  background: #f8f9fa !important;
  z-index: 2;
  padding: 1.2rem 2rem !important;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 0 0 18px 18px !important;
  border-top: 1px solid #e0e0e0 !important;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.custom-pdf-dialog .p-button {
  font-size: 1rem;
  border-radius: 8px;
  padding: 0.6rem 1.5rem;
}
</style>
